import React from 'react';
import { INTERACTIVE_ANALYTICS_COMMAND_HUB } from '../../../../content/enterpriseMessaging';
import { CommandHubVisual } from './InteractiveAnalyticsVisuals';
import { PBISection } from './PBIContent';

export default function CommandHubSection() {
  const copy = INTERACTIVE_ANALYTICS_COMMAND_HUB;

  return (
    <PBISection accent="operational" id="command-hub" tight>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center lg:gap-x-14">
        <div className="lg:order-1 w-full">
          <CommandHubVisual />
        </div>
        <div className="lg:order-2 lg:pl-2">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            {copy.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-600">{copy.body}</p>
          <ul className="mt-6 space-y-3">
            {copy.points.map((point) => (
              <li key={point.title} className="flex gap-3">
                <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-theme-green-500" />
                <div>
                  <p className="text-sm font-semibold text-ink-900">{point.title}</p>
                  <p className="mt-1 text-sm text-ink-600 leading-relaxed">{point.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </PBISection>
  );
}
